/**
 * Permissions cache storage. Kept in a separate module so it can be cleared
 * from the logout flow (AuthProvider) without creating circular dependencies.
 */

const CACHE_KEY = "user_permissions_cache";
let permissionsPromiseCache: Promise<any> | null = null;

const isBrowser = (): boolean => typeof window !== "undefined";

const safeSessionRemoveItem = (key: string): void => {
  if (!isBrowser()) return;
  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    console.warn("Failed to remove from session storage:", err);
  }
};

/** Clears the permissions session storage and in-memory promise cache. Call on logout. */
export function clearPermissionsCache(): void {
  safeSessionRemoveItem(CACHE_KEY);
  permissionsPromiseCache = null;
}

export function getPermissionsCacheKey(): string {
  return CACHE_KEY;
}

export function getPermissionsPromiseCache(): Promise<any> | null {
  return permissionsPromiseCache;
}

export function setPermissionsPromiseCache(p: Promise<any> | null): void {
  permissionsPromiseCache = p;
}
